import { render, staticRenderFns } from "./StatoFase.vue?vue&type=template&id=486683d6&scoped=true"
import script from "./StatoFase.vue?vue&type=script&lang=js"
export * from "./StatoFase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486683d6",
  null
  
)

export default component.exports